import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { postCreateMediaTag } from '../services/postCreateMediaTag.service';
import { selectMediaTagInputValue } from '../selectors/mediaTags.selectors';
import { selectSelectedFilePermissionId } from 'scenes/ProjectGallery/store/selectors/project-gallery-base.selectors';

/**
 * Creates a tag in the selected project and puts it on the selected file.
 * Without an argument the tag is named by the desktop tag field
 * (`selectMediaTagInputValue`); `{ name }` alone creates a free-form tag of
 * that name (the phone's add sheet), and `{ name, assignmentId,
 * assignmentNumberPath }` a tag made of an assignment.
 */
export const createProjectMediaTag = createAsyncThunk(
  'mediaTags/createProjectMediaTag',
  async (assignmentTagCreateData, { getState }) => {
    const projectId = selectSelectedProjectId(getState());

    const mediaTagName = selectMediaTagInputValue(getState());

    const selectedFilePermissionId = selectSelectedFilePermissionId(getState());

    let mediaTagAttributes;

    if (assignmentTagCreateData) {
      const { name, assignmentId, assignmentNumberPath } =
        assignmentTagCreateData;

      mediaTagAttributes = {
        name,
        fileId: selectedFilePermissionId,
        assignmentId,
        assignmentNumberPath,
      };
    } else {
      mediaTagAttributes = {
        name: mediaTagName,
        fileId: selectedFilePermissionId,
      };
    }

    const response = await postCreateMediaTag(projectId, mediaTagAttributes);
    return response;
  }
);
